module.exports = __webpack_public_path__ + "static/media/1000254037.ba80e8ea.jpg";